import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors } from '../../../assets/styles';

const useStyles = makeStyles((theme: Theme) => {
  const pxToRem = (px: number): string => `${px / 16}rem`;

  return {
    container: {
      padding: `${pxToRem(48)} ${pxToRem(140)} ${pxToRem(140)} ${pxToRem(140)}`,
    },
    header: {
      position: 'relative',
    },
    printBtn: {
      position: 'absolute',
      top: 10,
      right: 40,
    },
    emailBtn: {
      position: 'absolute',
      top: 10,
      right: 0,
    },
    title: {
      textAlign: 'center',
    },
    pdf: {
      transform: 'scale(0.8)',
      transformOrigin: '10% 5%',
      height: '10%',
      width: '980px',
      '& $pdfTitle': {
        display: 'block',
      },
    },
    pdfTitle: {   
      fontSize: 22,
    },
    emailInput: {
      width: 500,
    },
    completedDate: {
      textAlign: 'right',
      color: Colors.Gray6,
      paddingBottom: `0 !important`,
      '@media print': {
        display: 'block',
      },
    },
  };
});

export default useStyles;
